/*
Defines the custom element <ravel-sequencer>
*/

import { RavelSequencer } from './src/RavelSequencer.js';

customElements.define('ravel-sequencer', RavelSequencer);
